export const REGEX_DETECT_SCRIPT_TAG =
  /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
